import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {formatCurrency} from '../utils/currency';
import {formatNumber} from '../utils/number';
import StatusLabel from './StatusLabel';
import Loading from './Loading';

class SavedItems extends Component {
  render() {
    if (this.props.isFetching) {
      return (<Loading/>);
    }

    return this.props.items.length ?
      (
        <div>

          <div className="shopping-cart__headers">
            <div className="shopping-cart__headers__gradient"/>
            <div className="row column">
              <h1>Saved for later ({formatNumber(this.props.items.length)} {this.props.items.length === 1 ? 'item' : 'items'})</h1>
            </div>
          </div>

          <div className="row column">

            {this.props.items.map(product =>

              <div key={product.id} className="cart-item">
                <div className="row">
                  <div className="small-3 columns">
                    <div className="cart-item__image">
                      <a href={`${ROOT_URL}/product_detail.php?itemid=${product.id}&catid=${product.catId}`}>
                        <img src={`${ROOT_URL}/uploads/products/${product.image}`} />
                      </a>
                    </div>
                  </div>

                  <div className="small-7 columns">
                    <p className="cart-item__name">
                      <a href={`${ROOT_URL}/product_detail.php?itemid=${product.id}&catid=${product.catId}`}>{product.name}</a>
                    </p>
                    <p className="cart-item__status">
                      <StatusLabel remainingStock={product.remainingStock}
                                   isDiscontinued={product.isDiscontinued}
                                   isComingSoon={product.isComingSoon}
                                   callForPricing={product.callForPricing}
                                   specialShipDate={product.specialShipDate}
                                   specialShipDays={product.specialShipDays}
                                   backorderShipDate={product.backorderShipDate}
                                   backorderShipDays={product.backorderShipDays}/>
                    </p>
                    <span className="cart-item__actions">
                      <a onClick={e => this.props.onDelete(product.id)}>Delete</a>
                      <span> &nbsp; | &nbsp; </span>
                      <a onClick={e => this.props.onMoveToCart(product)}>Move to cart</a>
                    </span>
                  </div>

                  <div className="small-2 columns text-right">
                    <p className="cart-item__price">{formatCurrency(product.salePrice || product.price)}</p>
                  </div>
                </div>
              </div>

            )}

          </div>

        </div>
      )

      : null;
  }
}

SavedItems.propTypes = {
  items: PropTypes.array.isRequired,
  isFetching: PropTypes.bool.isRequired,
  onDelete: PropTypes.func.isRequired,
  onMoveToCart: PropTypes.func.isRequired,
  onMoveToYourProducts: PropTypes.func.isRequired,
};

export default SavedItems;
